import { render, staticRenderFns } from "./SiliconValleyHero.vue?vue&type=template&id=0b397e56&"
import script from "./SiliconValleyHero.vue?vue&type=script&lang=js&"
export * from "./SiliconValleyHero.vue?vue&type=script&lang=js&"
import style0 from "./SiliconValleyHero.vue?vue&type=style&index=0&id=0b397e56&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports